// Design tokens NSARA — source unique de la palette/l'échelle visuelle.
// Objectif: un vert NSARA reconnaissable sans que toute l'application soit
// verte (voir aussi index.css pour les variables CSS équivalentes, utilisées
// par les écrans à base de classes plutôt que de styles inline).
export const tokens = {
  colors: {
    primary: '#1B6B4A',
    primaryLight: '#2F8F68',
    primaryHover: '#123F2C',
    primarySoft: '#E7F3ED',
    secondary: '#B8752E',
    background: '#F7F8F6',
    surface: '#FFFFFF',
    border: '#E3E6E8',
    text: '#16181D',
    textMuted: '#6B7280',
    danger: '#C0362C',
    dangerSoft: '#FBEAE8',
    warning: '#B45309',
    warningSoft: '#FDF3E7',
    success: '#1B6B4A',
    successSoft: '#E7F3ED',
    info: '#2563EB',
    infoSoft: '#EAF1FE',
    // NSARA brand palette (landing page only — see src/styles/marketing.css).
    // Not used by the operational product UI above, which stays on the
    // background/surface/text tokens it already had.
    ink: '#14201B',
    deepForest: '#0F3B29',
    sage: '#9FB8A0',
    sageMist: '#EEF4EE',
    warmWhite: '#FAF8F3',
    warmGray: '#7A7568',
  },
  spacing: { xs: 4, sm: 8, md: 16, lg: 24, xl: 32, xxl: 48 },
  radius: { sm: 8, md: 10, lg: 12, xl: 16 },
  typography: { small: 12, body: 14, section: 18, page: 32 },
  // Dual-type system: Inter drives the whole application; Instrument Serif
  // is reserved for a small number of deliberate brand moments on the
  // landing page and must never appear in the operational product UI.
  fontFamily: {
    sans: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    serif: "'Instrument Serif', Georgia, 'Times New Roman', serif",
  },
  sizes: { control: 44, icon: 20, container: 1240 },
  shadows: {
    sm: '0 1px 2px rgba(15,23,23,0.06)',
    md: '0 4px 10px rgba(15,23,23,0.07)',
    lg: '0 10px 24px rgba(15,23,23,0.09)',
    xl: '0 20px 40px rgba(15,23,23,0.12)',
  },
  transition: '0.15s ease',
};

export default tokens;
